import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import Helmet from 'react-helmet';

import Avatar from './avatar';
import Static from './static';
import ImagePreloader from './image-preloader';
import { ArticleAd } from './ad';
import { formatAuthor, truncateSentence, splitArticle, buildTagLink } from '../utilities/formatting';
import commuteTimesChart from '../static/charts/commute-times.png';

export default ({ image, body, bodyText, title, tags, date, author, forAwards, entries, pathname, uid }) => (
    <Static>
        <Helmet
            title={title}
            meta={[
                { name: 'description', content: truncateSentence(bodyText) },
                { name: 'keywords', content: tags.join(',') },
                { property: 'og:title', content: title },
                { property: 'og:description', content: truncateSentence(bodyText) },
                { property: 'og:image', content: image.url },
                { name: 'twitter:card', content: 'summary_large_image' }
            ]}
        />
        <div css={{ width: '100%' }}>
            <h1 css={{ marginTop: 0, marginBottom: 4 }}>{title}</h1>
            <div css={{ display: 'flex', alignItems: 'center', flexFlow: 'wrap' }}>
                <span css={{ color: '#c1c0c0', marginRight: 20, marginTop: 8 }}>{date}</span>
                {tags.map((tag, index) => (
                    <Link
                        to={buildTagLink(tag, forAwards)}
                        key={index}
                        css={{
                            borderRadius: 12,
                            background: '#70ccf3',
                            padding: '4px 16px',
                            marginRight: 12,
                            marginTop: 8,
                            color: '#333',
                        }}
                    >{tag}</Link>
                ))}
            </div>
            <Img
                alt={title}
                fluid={image.localFile.childImageSharp.fluid}
                css={{
                    margin: '24px 0',
                    height: 400,
                    '@media(max-width: 767px)': {
                        height: 300,
                    },
                }}
            />
            {uid === 'charts-us-cities-average-rent' ? <a href="https://farm2.staticflickr.com/1769/43131787112_574fa038bd_o.png"><img height="522" css={{ width: '100%', height: 'auto' }} src="https://farm2.staticflickr.com/1769/43131787112_92eed660c0_b.jpg" alt="Rent Data - US" /></a> : null}
            {uid === 'worldwide-rental-price-index' ? <a href="https://farm1.staticflickr.com/915/28341255697_1dbd87422e_o.jpg"><img height="91" css={{ width: '100%', height: 'auto' }} src="https://farm1.staticflickr.com/915/28341255697_0d61cc8bc3_b.jpg" alt="Rent Data - Global" /></a> : null}
            {uid === 'chart-100-commute-2018' ? <a href={commuteTimesChart}><img height="273" css={{ width: '100%', height: 'auto' }} src={commuteTimesChart} alt="Commute Times" /></a> : null}
            {forAwards ?
                <div dangerouslySetInnerHTML={{ __html: body }} /> :
                <div>
                    <div dangerouslySetInnerHTML={{ __html: splitArticle(body)[0] }} />
                    <div css={{ marginTop: 16, marginBottom: 16 }}><ArticleAd key={pathname} /></div>
                    <div dangerouslySetInnerHTML={{ __html: splitArticle(body)[1] }} />
                </div>
            }
            {forAwards &&
                <div>
                    {entries.map(({ entryTitle, entryImage, entryText, entryRank }, index) => (
                        <div css={{ marginTop: 24 }} key={index}>
                            <h4 css={{ marginBottom: 16 }}>{`${entryRank}: ${entryTitle}`}</h4>
                            <div css={{ display: 'flex', '@media(max-width: 767px)': { flexDirection: 'column' } }}>
                                <div
                                    css={{
                                        marginRight: 20,
                                        width: 300,
                                        '@media(max-width: 767px)': {
                                            marginRight: 0,
                                            width: '100%',
                                            marginBottom: 16,
                                        },
                                    }}
                                >
                                    <Img
                                        alt={entryTitle}
                                        fixed={entryImage.localFile.childImageSharp.fixed}
                                        style={{ display: 'inherit' }}
                                        css={{
                                            height: 160,
                                            '@media(max-width: 767px)': {
                                                display: 'none',
                                            }
                                        }}
                                    />
                                    <Img
                                        alt={entryTitle}
                                        fluid={entryImage.localFile.childImageSharp.fluid}
                                        css={{
                                            height: 160,
                                            '@media(min-width: 768px)': {
                                                display: 'none',
                                            }
                                        }}
                                    />
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: entryText }} css={{ flex: '1' }} />
                            </div>
                            {index === 1 ? <div css={{ marginTop: 24 }}><ArticleAd key={pathname} /></div> : null}
                        </div>
                    ))}
                </div>
            }
            <div css={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
                <Avatar author={author} />
                <span>{formatAuthor(author)}</span>
            </div>
        </div>
    </Static>
);
